/**
 * weblabFormatters — 1:1 port of the standalone tracker's
 * components/utils/formatters.ts (currencyFormatter / numberFormatter).
 *
 * Kept identical so the FINN detail/summary panels format numbers exactly
 * like the Weblab Tracker: 0 fraction digits, en-US, USD currency.
 */

export function currencyFormatter(value: any, currency = "USD"): string {
  if (value === null || value === undefined || value === "" || isNaN(value)) {
    return "";
  }
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  return formatter.format(Number(value));
}

export function numberFormatter(value: any): string {
  if (value === null || value === undefined) {
    return "";
  }
  if (isNaN(value)) {
    return String(value);
  }
  const formatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  return formatter.format(Number(value));
}
